"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ruleset = void 0;
const ModelCommon_1 = require("./ModelCommon");
const typeName = 'Ruleset';
class Ruleset extends ModelCommon_1.ModelCommon {
    /**
     * Currently, can't inherit from `Thing`, as the constructor just expects `ob`
     * A consequence of `can't use prototype.constructor.name in Webpack`
     */
    constructor(ob) {
        super(typeName, ob);
        this.definition = {
            BooleanRule: [],
            MetricRule: [],
            /** @deprecated */
            GeofenceRule: undefined,
        };
        /** CRA — 2025 05: Possible deprecatable? */
        this.Group = ob.Group ?? undefined;
        this.global = ob.global ?? false;
        this.definition = ob.definition ?? {
            BooleanRule: [],
            MetricRule: [],
            GeofenceRule: undefined,
        };
        this.globallyApplyToObjectTypeId = ob.globallyApplyToObjectTypeId ?? false;
        this.validBetween = ob.validBetween;
        this.appliesToType = ob.appliesToType ?? undefined;
        this.setOperation = ob.setOperation;
        this.messageTemplate = ob.messageTemplate;
        this.escalationTemplate = ob.escalationTemplate;
        this.period = ob.period;
        this.unit = ob.unit;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            appliesToType: {
                type: 'String',
                label: 'Applies to type',
                editable: true,
            },
            globallyApplyToObjectTypeId: {
                type: 'Boolean',
                label: 'Always Apply To Type',
                editable: true,
            },
            RulesetBooleanRule: {
                type: 'Derived',
                label: 'Device Status Parameters',
                actions: {
                    create: true,
                    link: false,
                    delete: true,
                    edit: true,
                },
                valueFn: (state, functions, accessKey) => {
                    return { state, functions, BooleanRule: this.definition.BooleanRule };
                },
                viewName: 'RulesetBooleanRule',
            },
            RulesetMetricRule: {
                type: 'Derived',
                label: 'Device Measurement Parameters',
                actions: {
                    create: true,
                    link: false,
                    delete: true,
                    edit: true,
                },
                valueFn: (state, functions, accessKey) => {
                    return { state, functions, MetricRule: this.definition.MetricRule };
                },
                viewName: 'RulesetMetricRule',
            },
        };
    }
}
exports.Ruleset = Ruleset;
